import { NavLink, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Header } from "./Header";
import { UserBar } from "./UserBar";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  isActive ? "active" : undefined;

export function AuthGate() {
  const { loading, user, allowed } = useAuth();

  if (loading) {
    return (
      <>
        <Header />
        <main />
      </>
    );
  }

  if (!allowed || !user) {
    return <Navigate to="/login" replace />;
  }

  const nav = (
    <>
      <NavLink to="/automatic-run" className={navLinkClass}>
        Automatic run
      </NavLink>
      <NavLink to="/" end className={navLinkClass}>
        Dashboard
      </NavLink>
      <NavLink to="/contacts" className={navLinkClass}>
        Pulled contacts
      </NavLink>
      <NavLink to="/icps" className={navLinkClass}>
        ICPs
      </NavLink>
    </>
  );

  return (
    <>
      <Header nav={nav} right={<UserBar user={user} />} />
      <main>
        <Outlet />
      </main>
    </>
  );
}
